import React from 'react';

export const NotFound = () => <h1>Page not found</h1>;
